module.exports = __webpack_public_path__ + "discover.daf599.svg";